import Comps from '@owenscorning/react-library';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import styles from '../../shared/warranty-registration.module.scss';
import { hideLeakingModal } from '../redux/action.js';

const { Modal } = Comps.Connect;

const LeakingModal = props => (
  <Modal onClose={props.hideLeakingModal} open={props.showLeakingModal} className={styles.addressVerificationModal}>
    <p>
      If you are experiencing leaking issues, please reach out to a contractor. Click{' '}
      <a href="/roofing/contractors">HERE</a> for our Find a Contractor page if you do not already have one. If you have
      already done so and are still experiencing leaking issues, please call <strong>1-800-ROOFING.</strong>
    </p>
  </Modal>
);

const mapStateToProps = state => ({
  showLeakingModal: state.showLeakingModal,
});
const mapDispatchToProps = dispatch => ({
  hideLeakingModal: () => dispatch(hideLeakingModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeakingModal);
